
import type { ColorMap } from "./types";

// eslint-disable-next-line @typescript-eslint/naming-convention
export const svs_nitrogen_dioxide: ColorMap = {
  r: [0.027451, 0.027451, 0.0313726, 0.0313726, 0.0313726, 0.0352941, 0.0392157, 0.0392157, 0.0431373, 0.0431373, 0.0470588, 0.0509804, 0.0509804, 0.054902, 0.054902, 0.0588235, 0.0627451, 0.0627451, 0.0666667, 0.0666667, 0.0705882, 0.0745098, 0.0745098, 0.0784314, 0.0823529, 0.0823529, 0.0862745, 0.0901961, 0.0901961, 0.0941176, 0.0941176, 0.0980392, 0.101961, 0.101961, 0.105882, 0.109804, 0.113725, 0.117647, 0.121569, 0.12549, 0.133333, 0.137255, 0.145098, 0.14902, 0.156863, 0.164706, 0.172549, 0.180392, 0.188235, 0.196078, 0.207843, 0.215686, 0.223529, 0.231373, 0.239216, 0.25098, 0.258824, 0.266667, 0.278431, 0.286275, 0.294118, 0.301961, 0.313726, 0.321569, 0.329412, 0.337255, 0.345098, 0.356863, 0.364706, 0.372549, 0.380392, 0.388235, 0.4, 0.407843, 0.415686, 0.427451, 0.435294, 0.443137, 0.45098, 0.462745, 0.470588, 0.478431, 0.490196, 0.501961, 0.509804, 0.521569, 0.529412, 0.541176, 0.552941, 0.564706, 0.576471, 0.584314, 0.6, 0.607843, 0.619608, 0.631373, 0.639216, 0.654902, 0.662745, 0.67451, 0.686275, 0.694118, 0.705882, 0.713726, 0.72549, 0.737255, 0.745098, 0.756863, 0.764706, 0.772549, 0.784314, 0.792157, 0.803922, 0.811765, 0.819608, 0.827451, 0.835294, 0.847059, 0.85098, 0.858824, 0.870588, 0.87451, 0.882353, 0.890196, 0.898039, 0.905882, 0.909804, 0.917647, 0.92549, 0.929412, 0.937255, 0.941176, 0.94902, 0.952941, 0.960784, 0.964706, 0.972549, 0.976471, 0.980392, 0.984314, 0.988235, 0.988235, 0.992157, 0.992157, 0.992157, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 0.996078, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 0.996078, 0.996078, 0.996078, 0.992157, 0.992157, 0.988235, 0.984314, 0.980392, 0.976471, 0.972549, 0.968627, 0.964706, 0.956863, 0.94902, 0.945098, 0.933333, 0.92549, 0.917647, 0.905882, 0.898039, 0.886275, 0.87451, 0.858824, 0.847059, 0.835294, 0.819608, 0.803922, 0.788235, 0.772549, 0.760784, 0.741176, 0.72549, 0.705882, 0.690196, 0.67451, 0.65098, 0.635294, 0.615686, 0.596078, 0.580392, 0.556863, 0.541176, 0.521569, 0.501961, 0.486275, 0.466667, 0.45098, 0.427451, 0.411765, 0.396078, 0.376471, 0.364706, 0.345098, 0.329412, 0.317647, 0.298039, 0.286275, 0.270588, 0.258824, 0.247059, 0.235294, 0.227451, 0.219608, 0.211765, 0.211765, 0.207843, 0.207843, 0.211765, 0.211765, 0.215686, 0.223529, 0.227451, 0.231373],
  g: [0.0156863, 0.0156863, 0.0156863, 0.0196078, 0.0196078, 0.0196078, 0.0235294, 0.0235294, 0.0235294, 0.0235294, 0.027451, 0.027451, 0.027451, 0.0313726, 0.0313726, 0.0313726, 0.0352941, 0.0352941, 0.0352941, 0.0352941, 0.0392157, 0.0392157, 0.0392157, 0.0431373, 0.0431373, 0.0431373, 0.0470588, 0.0470588, 0.0470588, 0.0509804, 0.0509804, 0.0509804, 0.0509804, 0.054902, 0.054902, 0.054902, 0.0588235, 0.0588235, 0.0588235, 0.0588235, 0.0627451, 0.0627451, 0.0627451, 0.0627451, 0.0627451, 0.0627451, 0.0627451, 0.0627451, 0.0627451, 0.0627451, 0.0627451, 0.0627451, 0.0666667, 0.0666667, 0.0666667, 0.0666667, 0.0666667, 0.0666667, 0.0666667, 0.0666667, 0.0705882, 0.0705882, 0.0705882, 0.0745098, 0.0745098, 0.0784314, 0.0823529, 0.0823529, 0.0862745, 0.0901961, 0.0941176, 0.0980392, 0.101961, 0.105882, 0.105882, 0.109804, 0.113725, 0.117647, 0.121569, 0.12549, 0.129412, 0.133333, 0.137255, 0.141176, 0.141176, 0.145098, 0.14902, 0.152941, 0.156863, 0.160784, 0.164706, 0.168627, 0.172549, 0.176471, 0.180392, 0.184314, 0.188235, 0.192157, 0.196078, 0.2, 0.203922, 0.207843, 0.211765, 0.215686, 0.219608, 0.223529, 0.227451, 0.231373, 0.235294, 0.239216, 0.247059, 0.25098, 0.254902, 0.258824, 0.262745, 0.270588, 0.27451, 0.282353, 0.290196, 0.294118, 0.301961, 0.309804, 0.321569, 0.329412, 0.337255, 0.34902, 0.356863, 0.368627, 0.376471, 0.388235, 0.396078, 0.407843, 0.415686, 0.427451, 0.435294, 0.447059, 0.458824, 0.466667, 0.482353, 0.494118, 0.505882, 0.517647, 0.529412, 0.545098, 0.556863, 0.572549, 0.584314, 0.6, 0.615686, 0.627451, 0.643137, 0.654902, 0.670588, 0.686275, 0.698039, 0.709804, 0.721569, 0.733333, 0.74902, 0.756863, 0.772549, 0.780392, 0.792157, 0.803922, 0.811765, 0.823529, 0.831373, 0.843137, 0.85098, 0.862745, 0.870588, 0.878431, 0.890196, 0.898039, 0.905882, 0.913725, 0.921569, 0.929412, 0.937255, 0.941176, 0.94902, 0.952941, 0.960784, 0.964706, 0.968627, 0.972549, 0.976471, 0.976471, 0.980392, 0.980392, 0.980392, 0.980392, 0.976471, 0.976471, 0.972549, 0.968627, 0.964706, 0.960784, 0.956863, 0.952941, 0.945098, 0.941176, 0.937255, 0.929412, 0.92549, 0.917647, 0.913725, 0.905882, 0.901961, 0.894118, 0.886275, 0.882353, 0.878431, 0.870588, 0.866667, 0.858824, 0.854902, 0.847059, 0.839216, 0.835294, 0.827451, 0.823529, 0.815686, 0.807843, 0.8, 0.792157, 0.788235, 0.780392, 0.768627, 0.760784, 0.752941, 0.741176, 0.733333, 0.721569, 0.709804, 0.698039, 0.686275, 0.67451, 0.662745, 0.65098, 0.635294, 0.623529, 0.607843, 0.592157, 0.580392, 0.564706, 0.552941, 0.541176, 0.529412, 0.517647, 0.501961, 0.494118, 0.486275, 0.47451, 0.470588, 0.462745],
  b: [0.0509804, 0.054902, 0.0588235, 0.0627451, 0.0666667, 0.0745098, 0.0784314, 0.0862745, 0.0901961, 0.0941176, 0.101961, 0.109804, 0.113725, 0.121569, 0.12549, 0.133333, 0.141176, 0.145098, 0.152941, 0.156863, 0.164706, 0.172549, 0.180392, 0.184314, 0.192157, 0.196078, 0.203922, 0.211765, 0.215686, 0.223529, 0.227451, 0.235294, 0.243137, 0.247059, 0.254902, 0.262745, 0.266667, 0.27451, 0.282353, 0.286275, 0.294118, 0.301961, 0.309804, 0.317647, 0.32549, 0.333333, 0.341176, 0.352941, 0.360784, 0.368627, 0.376471, 0.384314, 0.396078, 0.403922, 0.411765, 0.419608, 0.427451, 0.435294, 0.443137, 0.45098, 0.454902, 0.462745, 0.466667, 0.470588, 0.47451, 0.478431, 0.482353, 0.486275, 0.486275, 0.490196, 0.490196, 0.490196, 0.494118, 0.494118, 0.494118, 0.498039, 0.498039, 0.498039, 0.498039, 0.501961, 0.501961, 0.501961, 0.501961, 0.501961, 0.501961, 0.501961, 0.501961, 0.498039, 0.498039, 0.498039, 0.494118, 0.494118, 0.494118, 0.490196, 0.490196, 0.490196, 0.486275, 0.486275, 0.482353, 0.482353, 0.478431, 0.47451, 0.47451, 0.470588, 0.466667, 0.462745, 0.458824, 0.454902, 0.45098, 0.447059, 0.443137, 0.439216, 0.435294, 0.431373, 0.431373, 0.423529, 0.423529, 0.419608, 0.415686, 0.411765, 0.407843, 0.403922, 0.4, 0.4, 0.396078, 0.392157, 0.388235, 0.384314, 0.380392, 0.376471, 0.368627, 0.364706, 0.360784, 0.352941, 0.34902, 0.341176, 0.337255, 0.329412, 0.32549, 0.321569, 0.317647, 0.313726, 0.313726, 0.313726, 0.313726, 0.317647, 0.321569, 0.32549, 0.333333, 0.337255, 0.34902, 0.356863, 0.364706, 0.376471, 0.384314, 0.392157, 0.403922, 0.411765, 0.423529, 0.431373, 0.443137, 0.45098, 0.462745, 0.47451, 0.482353, 0.498039, 0.505882, 0.517647, 0.533333, 0.54902, 0.564706, 0.576471, 0.592157, 0.611765, 0.623529, 0.643137, 0.654902, 0.670588, 0.686275, 0.694118, 0.709804, 0.717647, 0.72549, 0.733333, 0.737255, 0.741176, 0.745098, 0.745098, 0.741176, 0.737255, 0.729412, 0.72549, 0.717647, 0.705882, 0.698039, 0.686275, 0.678431, 0.670588, 0.658824, 0.65098, 0.643137, 0.639216, 0.631373, 0.627451, 0.627451, 0.627451, 0.627451, 0.627451, 0.631373, 0.631373, 0.635294, 0.639216, 0.643137, 0.65098, 0.654902, 0.658824, 0.662745, 0.662745, 0.666667, 0.670588, 0.670588, 0.67451, 0.67451, 0.67451, 0.67451, 0.67451, 0.67451, 0.678431, 0.678431, 0.682353, 0.686275, 0.686275, 0.690196, 0.698039, 0.701961, 0.709804, 0.713726, 0.717647, 0.72549, 0.733333, 0.737255, 0.745098, 0.74902, 0.756863, 0.760784, 0.764706, 0.768627, 0.772549, 0.772549, 0.776471, 0.776471, 0.776471, 0.776471, 0.776471, 0.776471, 0.776471],
};


export const svsColorRamp = {
  "type": "multipart",
  "colorRamps": [
    {
      "type": "algorithmic",
      "fromColor": [
        7,
        4,
        13,
        255
      ],
      "toColor": [
        13,
        7,
        29,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.0,
      "stop": 0.047619047619047616
    },
    {
      "type": "algorithmic",
      "fromColor": [
        13,
        7,
        29,
        255
      ],
      "toColor": [
        20,
        11,
        49,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.047619047619047616,
      "stop": 0.09523809523809523
    },
    {
      "type": "algorithmic",
      "fromColor": [
        20,
        11,
        49,
        255
      ],
      "toColor": [
        29,
        14,
        68,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.09523809523809523,
      "stop": 0.14285714285714285
    },
    {
      "type": "algorithmic",
      "fromColor": [
        29,
        14,
        68,
        255
      ],
      "toColor": [
        49,
        16,
        93,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.14285714285714285,
      "stop": 0.19047619047619047
    },
    {
      "type": "algorithmic",
      "fromColor": [
        49,
        16,
        93,
        255
      ],
      "toColor": [
        76,
        17,
        117,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.19047619047619047,
      "stop": 0.23809523809523808
    },
    {
      "type": "algorithmic",
      "fromColor": [
        76,
        17,
        117,
        255
      ],
      "toColor": [
        103,
        26,
        126,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.23809523809523808,
      "stop": 0.2857142857142857
    },
    {
      "type": "algorithmic",
      "fromColor": [
        103,
        26,
        126,
        255
      ],
      "toColor": [
        133,
        36,
        128,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.2857142857142857,
      "stop": 0.3333333333333333
    },
    {
      "type": "algorithmic",
      "fromColor": [
        133,
        36,
        128,
        255
      ],
      "toColor": [
        167,
        49,
        123,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.3333333333333333,
      "stop": 0.38095238095238093
    },
    {
      "type": "algorithmic",
      "fromColor": [
        167,
        49,
        123,
        255
      ],
      "toColor": [
        197,
        61,
        113,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.38095238095238093,
      "stop": 0.42857142857142855
    },
    {
      "type": "algorithmic",
      "fromColor": [
        197,
        61,
        113,
        255
      ],
      "toColor": [
        223,
        80,
        102,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.42857142857142855,
      "stop": 0.47619047619047616
    },
    {
      "type": "algorithmic",
      "fromColor": [
        223,
        80,
        102,
        255
      ],
      "toColor": [
        244,
        110,
        89,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.47619047619047616,
      "stop": 0.5238095238095237
    },
    {
      "type": "algorithmic",
      "fromColor": [
        244,
        110,
        89,
        255
      ],
      "toColor": [
        253,
        148,
        81,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.5238095238095237,
      "stop": 0.5714285714285714
    },
    {
      "type": "algorithmic",
      "fromColor": [
        253,
        148,
        81,
        255
      ],
      "toColor": [
        253,
        190,
        107,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.5714285714285714,
      "stop": 0.6190476190476191
    },
    {
      "type": "algorithmic",
      "fromColor": [
        253,
        190,
        107,
        255
      ],
      "toColor": [
        253,
        221,
        144,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.6190476190476191,
      "stop": 0.6666666666666666
    },
    {
      "type": "algorithmic",
      "fromColor": [
        253,
        221,
        144,
        255
      ],
      "toColor": [
        254,
        245,
        185,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.6666666666666666,
      "stop": 0.7142857142857142
    },
    {
      "type": "algorithmic",
      "fromColor": [
        254,
        245,
        185,
        255
      ],
      "toColor": [
        245,
        247,
        177,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.7142857142857142,
      "stop": 0.7619047619047619
    },
    {
      "type": "algorithmic",
      "fromColor": [
        245,
        247,
        177,
        255
      ],
      "toColor": [
        214,
        232,
        160,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.7619047619047619,
      "stop": 0.8095238095238095
    },
    {
      "type": "algorithmic",
      "fromColor": [
        214,
        232,
        160,
        255
      ],
      "toColor": [
        163,
        213,
        170,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.8095238095238095,
      "stop": 0.8571428571428571
    },
    {
      "type": "algorithmic",
      "fromColor": [
        163,
        213,
        170,
        255
      ],
      "toColor": [
        106,
        189,
        175,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.8571428571428571,
      "stop": 0.9047619047619047
    },
    {
      "type": "algorithmic",
      "fromColor": [
        106,
        189,
        175,
        255
      ],
      "toColor": [
        60,
        151,
        192,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.9047619047619047,
      "stop": 0.9523809523809523
    },
    {
      "type": "algorithmic",
      "fromColor": [
        60,
        151,
        192,
        255
      ],
      "toColor": [
        59,
        117,
        198,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.9523809523809523,
      "stop": 1.0
    }
  ]
};
